export default {
  birthDateInvalid:
    "Data non valida. Devi avere tra 18 e 110 anni (anno da {{minYear}} a {{maxYear}})",
  documentDateInvalid:
    "Data non valida. L’anno deve essere tra 2000 e {{maxYear}}",
  maxChars: "Deve contenere al massimo {{max}} caratteri",
  fieldRequired: "{{field}} è obbligatorio",
  fieldMinChars: "{{field}} deve contenere almeno {{min}} caratteri",
  fieldMaxChars: "{{field}} deve contenere al massimo {{max}} caratteri",
  fields: {
    firstName: "Nome",
    lastName: "Cognome",
    taxId: "Codice fiscale / ID fiscale",
    companyName: "Ragione sociale",
    vatNumber: "Partita IVA",
    companyTaxId: "Codice fiscale azienda",
    birthDate: "Data di nascita",
    birthPlace: "Luogo di nascita",
    street: "Indirizzo",
    postalCode: "CAP",
    city: "Città",
    province: "Provincia",
    country: "Paese",
    documentType: "Tipo documento",
    documentNumber: "Numero documento",
    documentIssuer: "Ente di rilascio",
    documentIssueDate: "Data di rilascio documento",
    documentExpiryDate: "Data di scadenza documento",
    contactPhone: "Telefono",
    contactEmail: "Email",
    pec: "PEC",
    legalRepName: "Rappresentante legale",
    accountHolder: "Intestatario conto",
  },
  invalidEmailFormat: "Formato email non valido",
  invalidPhoneFormat:
    "Numero non valido. Usa il formato internazionale con prefisso + (es. +393331234567).",
  invalidNotificationChannel:
    "Seleziona WhatsApp o email per le notifiche prenotazioni",
  invalidNotificationLanguage: "Seleziona una lingua per le notifiche",
  ibanLength: "L’IBAN deve contenere tra 15 e 34 caratteri",
  documentExpiryBeforeIssue:
    "La data di scadenza non può precedere la data di rilascio",
} as const;
